<template>
  <span>
    <v-menu bottom v-model="menuOpened" :offset-y="true" transition="slide-y-transition">
      <template v-slot:activator="{ on }">
        <span>
          <v-btn color="primary" v-on="on" :disabled="disabled">
            <v-icon left>mdi-link</v-icon>{{$t('common.invitation-link')}}
          </v-btn>
          <help-icon class="ml-1" :text="$t('common.invitation-link-notice')"/>
        </span>
      </template>
      <v-list>
        <v-list-item @click="doCopy">
          <v-list-item-title>
            <v-icon left>mdi-content-copy</v-icon>{{$t('common.copy-to-clipboard')}}
          </v-list-item-title>
        </v-list-item>
        <v-list-item :href="'whatsapp://send?text=' + encodeURIComponent(invitationText)">
          <v-icon left>mdi-whatsapp</v-icon>
          <v-list-item-title>{{$t('common.share-via-whatsapp')}}</v-list-item-title>
        </v-list-item>
        <v-list-item :href="'mailto:?body=' + encodeURIComponent(invitationText) + '&amp;subject=' + encodeURIComponent(invitationSubject)">
          <v-icon left>mdi-email</v-icon>
          <v-list-item-title>{{$t('common.share-via-email')}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </span>
</template>

<script>
import { MUTATION_RAISE_NOTIFICATION } from "@/plugins/store";
import HelpIcon from "@/widgets/HelpIcon";

export default {
  name: "InvitationWidget",
  components: {
    HelpIcon,
  },
  props: {
    game: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    invitationText: function() {
      var text = 'Hey, du wurdest zu einem Wettkampf auf eSpocial eingeladen. Klicke auf den Link um die Einladung anzuzeigen:';
      text += '\n' + this.game.invitationLink;
      text += '\n' + 'Viel Spaß beim Zocken!';
      return text;
    },
    invitationSubject: function() {
      return 'eSpocial Einladung zum Wettkampf "' + this.game.name + '"';
    },
  },
  data: function() {
    return {
      menuOpened: false,
      showInvitationTooltip: false
    };
  },
  watch: {},
  mounted() {},
  methods: {
    doCopy: function() {
      this.$copyText(this.game.invitationLink).then(
        this.onInvitationLinkCopied,
        this.onInvitationLinkCopyError
      );
    },
    onInvitationLinkCopied() {
      this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
        message: this.$t('common.copy-to-clipboard-success'),
        type: "success"
      });
    },
    onInvitationLinkCopyError() {
      this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
        message: this.$t('common.copy-to-clipboard-failed'),
        type: "error"
      });
    }
  }
};
</script>